import React from 'react'


function PasswordInputField({ handleValidation, handlePasswordChange, passwordValue, passwordError }) {
  return (
    <>
        <div className="text-danger message alert text-center">{passwordError}</div>
        <div className="input-field form-group my-3  ">

          <span className="ico-label"><i className="icomoon-icon icon-lock"></i></span>
          <input type="password" required="required" value={passwordValue} placeholder="كلمة المرور" onChange={handlePasswordChange} onKeyUp={handleValidation} name="password" className="form-control" />
          <div class="required">*</div>
        </div>
    </>
  )
}
export default PasswordInputField;